/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type EstimateLimitMarginOrderQueryVariables = Types.Exact<{
	input: Types.EstimateLimitMarginOrderRequest;
}>;

export type EstimateLimitMarginOrderQuery = {
	__typename?: "Query";
	estimateLimitMarginOrder:
		| {
				__typename?: "DecreasedLimitOrderPosition";
				exitOrderType: Types.ExitMarginOrderType;
				userJourney?: string | null;
				destinationWalletSymbol?: string | null;
				isFeeTransparent: boolean;
				repayingFundsInUnderlyingAsset: string;
				remainingFundsInUnderlyingAsset: string;
				underlyingAsset: { __typename?: "EstimateLimitMarginOrderAmount"; id: string; amount: string };
				tradeFiat: { __typename?: "EstimateLimitMarginOrderAmount"; id: string; amount: string };
				fee?: {
					__typename?: "Fee";
					fiat: { __typename?: "FeeAmount"; value: string };
					asset: { __typename?: "FeeAmount"; value: string };
					net: { __typename?: "FeeAmount"; value: string };
					priceWithoutFee: { __typename?: "FeeAmount"; value: string };
					percentage: { __typename?: "FeePercentage"; value: string };
				} | null;
				serverTime: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		  }
		| { __typename?: "IncreasedLimitOrderPosition"; id: string };
};

export const EstimateLimitMarginOrderDocument = gql`
	query estimateLimitMarginOrder($input: EstimateLimitMarginOrderRequest!) {
		estimateLimitMarginOrder(input: $input) {
			... on IncreasedLimitOrderPosition {
				id
			}
			... on DecreasedLimitOrderPosition {
				underlyingAsset {
					id
					amount
				}
				tradeFiat {
					id
					amount
				}
				exitOrderType
				userJourney
				destinationWalletSymbol
				isFeeTransparent
				fee {
					fiat {
						value
					}
					asset {
						value
					}
					net {
						value
					}
					priceWithoutFee {
						value
					}
					percentage {
						value
					}
				}
				serverTime {
					iso8601
					unixTimestamp
				}
				repayingFundsInUnderlyingAsset
				remainingFundsInUnderlyingAsset
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class EstimateLimitMarginOrderGQLService extends Apollo.Query<
	EstimateLimitMarginOrderQuery,
	EstimateLimitMarginOrderQueryVariables
> {
	document = EstimateLimitMarginOrderDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
